module.exports = __webpack_public_path__ + "static/img/gravity.e508d8b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/svg/gravity.svg
// module id = FtDX
// module chunks = 1